/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Headers_1Inputs */

const en_gc_search_guides_what_is_gridcraft_sections_3_table_headers_1 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Headers_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A useful starting point`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_3_table_headers_1 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Headers_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适合的起点`)
};

/**
* | output |
* | --- |
* | "A useful starting point" |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Headers_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_3_table_headers_1 = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Headers_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Headers_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_3_table_headers_1(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_3_table_headers_1(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_3_table_headers_1 as "gc.search_guides.what_is_gridcraft.sections.3.table.headers.1" }